import { FormValidationSchema } from "@/components/Form/types";
import { I_RegisterPage } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { EMAIL_PATTERN } from "./patterns";

export const registerValidation = (data: I_RegisterPage): FormValidationSchema[] => [
  {
    name: "email",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("email", "required", data),
      },
      pattern: {
        value: EMAIL_PATTERN,
        message: getRuleErrorMessage("email", "pattern", data),
      },
    },
  },
];
